import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const activateContract = (id,items,amort)=> {
	return axios.post(API + "contracts/contractlineofcredit-activate/"+id+"/" ,{items,amort},{ headers: authHeader() })}

const ActivateContractLineOfCreditService = {
    activateContract,
  };
  export default ActivateContractLineOfCreditService;